module.exports = __webpack_public_path__ + "img/ennetix-report-page5.219cbbbe.png";